import React from "react";

function Prosample(props) {
  const { imgSrc, title, description, liveDemoLink, sourceCodeLink, author } =
    props;

  return (
    <>
      <div className="project" data-aos="fade-up">
        <div className="project-img">
          <img src={imgSrc} alt="" className="work-img" />
        </div>

        <div className="date-posted">
          <div className="who-post">
            <p className="admin">{author}</p>
          </div>
        </div>
        <div className="work-details">
          <h2> {title}</h2>
          <p className="work-info"> {description} </p>
          <div className="project-links">
            <a href={liveDemoLink} target="_blank" rel="noopener noreferrer">
              <h6 className="learnmore">
                <i class="fa fa-laptop" aria-hidden="true"></i>&nbsp; Live Demo
              </h6>
            </a>
            <a href="" target="_blank" rel="noopener noreferrer">
              <h6 className="learnmore">
                <i class="fa fa-github" aria-hidden="true"></i> &nbsp;
                {sourceCodeLink}
              </h6>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Prosample;
